import { cantUpdateInternalName } from './constants';

export function canUpdateInternalName(question) {
  return !cantUpdateInternalName.includes(question.internal_name);
}
